import { getUserFromStorage } from "@/utils/user-store.util";
import { useAdaptCourseStore } from "../adapt-course";
import { useAdaptChapterStore } from "../adapt-chapter";
import { StatusProgress, useAdaptProgressStore } from "../adapt-progress";
import { TypeAlert, useAlertStore } from ".";
import { useLearningObjectiveStore } from "../learning-objective";
import { useAdaptQuizStore } from "../adapt-quiz";
import { RouteMaterials, useAdaptMaterialStore } from "../adapt-material";
import { GenericsUtils } from "@/utils/generics.util";
import { useAuthStore } from "@/store/auth";


function getIntroCourseMessage() {
  return {
    bigTitle: useAdaptCourseStore?.course?.courseName,
    title: `Olá, ${
      getUserFromStorage()?.firstName
    }! Eu sou o Homero e serei seu guia no curso.`,
    message: `Neste capítulo, você verá sobre: ${
      useAdaptChapterStore?.getCurrentChapter()?.description
    }`,
    homeroAvatar: require("@/assets/images/avatares/happy-1.gif"),
    iconTitle: require("@/assets/images/icons-alert/chapter.svg"),
    buttons: [
      {
        name: "Iniciar curso",
        action: () => {
          useAdaptCourseStore.course.hasStarted = true;
          useAdaptProgressStore?.setNextState();
        },
        color: "btn-primary",
      },
    ],
  };
}

function getIntroChapterMessage() {
  return {
    bigTitle: useAdaptChapterStore?.chapter?.name,
    title: "Neste capítulo, você verá sobre:",
    message: useAdaptChapterStore?.chapter?.description,
    homeroAvatar: require("@/assets/images/avatares/happy-1.gif"),
    iconTitle: require("@/assets/images/icons-alert/chapter.svg"),
    buttons: [
      {
        name: "Iniciar capítulo",
        action: () => useAlertStore?.setType(TypeAlert.INTRO_OBJECTIVE),
        color: "btn-primary",
      },
    ],
  };
}
function getContinueChapterMessage() {
  return {
    bigTitle: useAdaptChapterStore?.chapter?.name,
    title: `Olá, tudo bem com você? Você parou neste capítulo, que fala sobre:`,
    message: useAdaptChapterStore?.chapter?.description,
    homeroAvatar: require("@/assets/images/avatares/happy-1.gif"),
    iconTitle: require("@/assets/images/icons-alert/chapter.svg"),
    buttons: [
      {
        name: "Continuar capítulo",
        action: () => {
          useAlertStore?.setCurrentAlert(TypeAlert.INTRO_OBJECTIVE, true);
          useAdaptProgressStore?.setNextState;
        },
        color: "btn-primary",
      },
    ],
  };
}
function getIntroObjeciveMessage() {
  return {
    bigTitle: useLearningObjectiveStore?.learningObjective?.name,
    title: `Neste Objetivo de aprendizagem iremos aprender sobre: `,
    message: useLearningObjectiveStore?.learningObjective?.description,
    homeroAvatar: require("@/assets/images/avatares/happy-1.gif"),
    iconTitle: require("@/assets/images/icons-alert/learning-objective.svg"),
    buttons: [
      {
        name: useAdaptMaterialStore?.hasStarted?"Continuar":"Começar",
        action: () => {
          useAdaptProgressStore.status = StatusProgress.INIT_OBJECTIVE;
          useAlertStore.show = false;
          useAdaptProgressStore?.setNextState();
        },
        color: "btn-primary",
      },
    ],
  };
}
function getIntroQuizMessage() {
  return {
    bigTitle: "Orientações sobre o quiz",
    title:
      "Você também pode responder a questão por áudio falando “Responder”, diga o texto do item que você achar que é o certo ou fale “Marque a opção X”",
    message: `Vamos iniciar agora o quiz, leia a questão e marque o item que você achar que é o correto.`,
    homeroAvatar: require("@/assets/images/avatares/happy-1.gif"),
    iconTitle: require("@/assets/images/icons-alert/star.svg"),
    buttons: [
      {
        name: "Começar",
        action: () => {
          useAdaptProgressStore?.setNextState();
        },
        color: "btn-outline-bg-white",
      },
    ],
  };
}
function getQuizMessage() {
  return {
    bigTitle: "Teste seus conhecimentos",
    title: `Próximo passo `,
    message: `Antes de seguir para o próximo objetivo de aprendizagem, vamos testar seus conhecimentos. Você terá cerca de ${new GenericsUtils().getDurationTime(
      useAdaptQuizStore?.messageData?.duration
    )} para responder ${
      useAdaptQuizStore?.messageData?.amountQuestions
    } questões de múltipla escolha. Não se preocupe: caso ache que o material visto não foi o suficiente, posso te apresentar mais aulas sobre o objetivo. `,
    homeroAvatar: require("@/assets/images/avatares/happy-1.gif"),
    iconTitle: require("@/assets/images/icons-alert/star.svg"),
    buttons: [
      {
        name: "Iniciar quiz",
        action: () => {
          useAdaptProgressStore?.setNextState();
          useAlertStore?.setCurrentAlert(TypeAlert.QUIZ_INIT, true);
        },
        color: "btn-outline-bg-white",
      },
      {
        name:
        useAdaptMaterialStore.routeMaterial === RouteMaterials.MORE
            ? "Ver novamente"
            : "Assisir mais aulas",
        action: () => {
          useAdaptMaterialStore?.setMoreMaterial(RouteMaterials.MORE);
        },
        color: "btn-outline-bg-white",
      },
    ],
  };
}
function getEndCourseMessage() {
  return {
    bigTitle: "Você concluiu o curso!",
    title: `Parabéns, ${useAuthStore?.data?.firstName}!`,
    message: `Você finalizou a sua jornada de estudos no curso ${useAlertStore?.data?.course}, agora você pode receber o seu certificado.`,
    homeroAvatar: require("@/assets/images/avatares/happy-1.gif"),
    iconTitle: require("@/assets/images/icons-alert/star.svg"),
    buttons: [
      {
        name: "Ver certificado",
        action: () => {
          useAdaptProgressStore.status = StatusProgress.CERTIFICATE;
          useAlertStore?.hideAlert();
        },
        color: "btn-primary",
      },
      {
        name: "Veja toda a sua jornada de aprendizado",
        action: () => {
          useAdaptMaterialStore?.setShowMap(true);
        },
        color: "btn-outline-bg-white",
      },
    ],
  };
}

function getEndCourseWithoutCertificateMessage() {
  return {
    bigTitle: "Objetivo de aprendizagem concluído!",
    title: `Parabéns, ${useAuthStore?.data?.firstName}!`,
    message: `Você finalizou todas as aulas desse objetivo, ${useAlertStore?.data?.course}. Parabéns pelo seu desempenho e dedicação no curso. Esse curso não possui certificado.`,
    homeroAvatar: require("@/assets/images/avatares/happy-1.gif"),
    iconTitle: require("@/assets/images/icons-alert/star.svg"),
    buttons: [
      {
        name: "Veja toda a sua jornada de aprendizado",
        action: () => {
          useAdaptMaterialStore?.setShowMap(true);
        },
        color: "btn-outline-bg-white",
      },
    ],
  };
}

export {
  getIntroCourseMessage,
  getIntroChapterMessage,
  getContinueChapterMessage,
  getIntroObjeciveMessage,
  getIntroQuizMessage,
  getQuizMessage,
  getEndCourseMessage,
  getEndCourseWithoutCertificateMessage,
};
